import React from 'react';
import classNames from 'classnames';

import './text.scss';

const Text = ({ element = 'p', type = 'body', children, style: overwriteStyle, className, ...attr }) => {
  const Element = element;
  const allTypes = ['body', 'meta', 'meta-2', 'display'];
  let classname = '';
  if (type === 'body') classname = 'bambuser-text-element-body';
  if (type === 'meta') classname = 'bambuser-text-element-meta';
  if (type === 'meta-2') classname = 'bambuser-text-element-meta-2';
  if (type === 'display') classname = 'bambuser-text-element-display';

  if (!allTypes.includes(type)) {
    throw Error(`${type} is invalid for Text, these are valid ${allTypes}`);
  }

  return (
    <Element style={overwriteStyle} className={classNames('bambuser-text-element', classname, className)} {...attr}>
      {children}
    </Element>
  );
};

export default Text;
